export default __webpack_public_path__ + "static/media/bg.093d36bb.png";